import React from "react";
import ComponentLoading from "../Shared/ComponentLoading";

export default class ComponentError extends React.Component {

    constructor (props) {

        super(props);
        this._isMounted = false;
        this.state = {
            "retrying": false
        };

    }

    componentDidMount () {

        this._isMounted = true;

    }

    componentWillUnmount () {

        this._isMounted = false;

    }

    handleOnClickRetry () {

        this.setState({
            "retrying": true
        });

        this.props.retry().then(() => {

            if (this._isMounted) {

                this.setState({
                    "retrying": false
                });

            }

        });

    }

    render () {

        if (this.props.support) {
            window.location = "ServerError";
            return;
        }

        if (this.state.retrying) {

            return (
                <div className="ErrorDiv">
                    <p className="mb-1">
                        {this.props.pageText.retrying}
                    </p>
                    <ComponentLoading />
                </div>
            );

        }

        return (
            <div className="ErrorDiv">
                <p className="mb-1">
                    {this.props.pageText.errorTitle}
                </p>
                <p>
                    <button type="button"
                        className="btn btn-dark btn-sm mt-0 mb-0"
                        onClick={() => this.handleOnClickRetry()}>
                        {this.props.pageText.retryButton}
                    </button>
                </p>
            </div>
        );


    }

}
